<app-header></app-header>
<div class="wrapper">
  <section class="related-search upcoming" *ngIf="!shimarStatus">
    <div class="container" *ngIf="noRecordStatus">
      <div class="record-not-available">
        <div class="text-center">
          <img src="assets/images/no-recoard-playlist.png">
          <p class="no-recored-content text-secondary">{{ "RECORD_NOT_FOUND" | translate }}</p>
        </div>
      </div>
    </div>
    <div *ngFor="let category of subcategory;" class="container">
      <div>
        <div *ngIf="category?.content?.length>0" class="section-head row pl-3">
          <h2>{{category | languageTranslate}}</h2>
          <a *ngIf="category.content.length > 7" href="javascript:void(0)" class="view-all-link"
            routerLink="/language-list/{{apiParam.slug}}/{{category?.slug}}">
            {{ "HOME.VIEW_ALL" | translate }}
          </a>
        </div>
        <div class="row custome-set">
          <div class="series-box" *ngFor="let data of category?.content; let i=index;">
            <app-grid [data]="data" [gridType]="'landscape'"></app-grid>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="loadMore" class="w-100">
      <article class="related-search sim-gallery">
        <div class="container">
          <div class="row custome-set mb-3">
            <div class="series-box">
              <div class="simmer-animation series-img"></div>
              <!-- <div class="series-content">
                <div class="simmer-animation w-100 simmer-animation sim-date"></div>
              </div> -->
            </div>
            <div class="series-box">
              <div class="simmer-animation series-img"></div>
              <!-- <div class="series-content">
                <div class="simmer-animation w-100 simmer-animation sim-date"></div>
              </div> -->
            </div>
            <div class="series-box">
              <div class="simmer-animation series-img"></div>
              <!-- <div class="series-content">
                <div class="simmer-animation w-100 simmer-animation sim-date"></div>
              </div> -->
            </div>
            <div class="series-box">
              <div class="simmer-animation series-img"></div>
              <!-- <div class="series-content">
                <div class="simmer-animation w-100 simmer-animation sim-date"></div>
              </div> -->
            </div>
            <div class="series-box">
              <div class="simmer-animation series-img"></div>
              <!-- <div class="series-content">
                <div class="simmer-animation w-100 simmer-animation sim-date"></div>
              </div> -->
            </div>
          </div>
        </div>
      </article>
    </div>
  </section>
  <app-grid-simmer class="search-page list-simmer" *ngIf="shimarStatus"></app-grid-simmer>
</div>
<app-footer></app-footer>